import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorSurface } from 'ext-ui/style/colors'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  sidenavCollapsedWidth,
  sidenavExpandedWidth,
} from 'src/components/SidenavWrapper/sidenav.constants'
import {
  selectIsSidenavLockedOpenFromState,
  selectShowSidenavLargeFromState,
} from 'src/redux/selectors/app.selectors'
import { selectFixedElementPushdown } from 'src/redux/selectors/css.selectors'
import { css } from 'styled-components'

interface BackgroundPageProps {
  className?: string
  backgroundColor?: string
  onClick?: () => void
  fixedPageSize?: boolean
}

const BackgroundPage: React.FC<React.PropsWithChildren<BackgroundPageProps>> = (
  props,
): React.ReactElement => {
  const fixedElementPushdown = useSelector(selectFixedElementPushdown)
  const showSidenavLarge = useSelector(selectShowSidenavLargeFromState)
  const sideNavLockedOpen = useSelector(selectIsSidenavLockedOpenFromState)
  const rightShift = sideNavLockedOpen
    ? `${sidenavExpandedWidth}px`
    : `${sidenavCollapsedWidth}px`

  return (
    <div
      className={props.className}
      css={css`
        top: ${fixedElementPushdown}px;
        height: ${props.fixedPageSize
          ? `calc(100vh - ${fixedElementPushdown}px)`
          : '100%'};
        max-height: ${props.fixedPageSize
          ? `calc(100vh - ${fixedElementPushdown}px)`
          : 'none'};
        background-color: ${props.backgroundColor ?? base_colorSurface};
        flex-grow: 2;
        display: flex;
        flex-direction: column;
        width: calc(100% - ${rightShift});
        max-width: ${props.fixedPageSize
          ? `calc(100% - ${rightShift})`
          : 'none'};
        position: relative;
        transition:
          width 0.3s ease,
          max-width 0.3s ease;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          width: 100%;
          max-width: ${props.fixedPageSize ? `100%` : 'none'};
        `)}

        ${!showSidenavLarge
          ? css`
              width: 100%;
            `
          : css``}
      `}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
    >
      {props.children}
    </div>
  )
}

export default BackgroundPage
